import type { MenuLocales } from '@/types/lang/locales'

export const menuEn: MenuLocales = {
    administration: {
        api: 'API',
        deviceConfiguration: 'Device settings',
        devices: 'Devices',
        devicesConfig: 'Configurations',
        devicesFirmware: 'Firmwares',
        devicesTemplate: 'Templates',
        devicesTemplateKeys: 'Template keys',
        devicesTypes: 'Device types',
        organizations: 'Organizations',
        roles: 'Roles & permissions',
        title: 'Administration',
        users: 'Users'
    },
    organization: 'My organization',
    checkpoints: 'Checkpoints',
    deimpersonate: 'Deimpersonate',
    detections: 'Reads',
    devices: 'Devices',
    events: 'Events',
    home: 'Home',
    logout: 'Logout',
    myAccount: 'My account',
    recentlyVisited: 'Last event visited',
    technician: {
        documentations: 'Documentations',
        inventory: 'Inventory',
        questions: 'Questions',
        tickets: 'Tickets',
        title: 'Technician',
        topics: 'Topics'
    },
    tickets: 'Tickets',
    type: {
        create: 'Create',
        detail: 'Detail',
        generate: 'Generation',
        list: 'List'
    },
    supportFaq: 'Support & questions'
}
